import React from 'react';

import UserSkeleton from '~/boilerplates/User';
import Dashboard from '~/containers/User/CES/Dashboard';
import { DashboardContextProvider } from '~/contexts/CES/DashboardContext';

export default function index() {
  return (
    <UserSkeleton>
      <DashboardContextProvider>
        <Dashboard />
      </DashboardContextProvider>
    </UserSkeleton>
  );
}
